export default __webpack_public_path__ + "static/media/car2.61335cbc.jpg";